import { adminRepositories } from "data/admin/repositories";

export const alertsRepo = {
  list(params = {}) {
    return adminRepositories.alerts.list({ includeDeleted: true, ...params });
  },
  create(alert) {
    return adminRepositories.alerts.create(alert);
  },
  remove(id) {
    return adminRepositories.alerts.remove(id);
  },
  update(id, patch) {
    return adminRepositories.alerts.update(id, patch);
  },
};
